import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, HostBinding, ContentChildren, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import * as i4 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import * as i1$1 from '@angular/cdk/layout';
import { Breakpoints, LayoutModule } from '@angular/cdk/layout';
import * as i2$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as Muuri from 'muuri/dist/muuri';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { fromEvent } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';

class WidgetComponent {
    constructor(element) {
        this.element = element;
        this.hideCard = false;
        this.hide = new EventEmitter();
        this.sizeChange = new EventEmitter();
        this.moveableClass = false;
        this.isEditMode = false;
        this.isHidden = false;
    }
    ngOnInit() {
        this.width = this.element.nativeElement.offsetWidth;
        this.height = this.element.nativeElement.offsetHeight;
    }
    ngDoCheck() {
        // TODO: When widget resizing gets added, you may want to disable this check during a resize! Try it out and see what happens
        if (this.element.nativeElement.offsetWidth !== this.width ||
            this.element.nativeElement.offsetHeight !== this.height) {
            this.width = this.element.nativeElement.offsetWidth;
            this.height = this.element.nativeElement.offsetHeight;
            this.sizeChange.emit();
        }
    }
    toggleEditMode(isActive) {
        this.moveableClass = isActive;
        this.isEditMode = isActive;
    }
    toggleHidden(isHidden, animation = true) {
        this.isHidden = isHidden;
        if (isHidden) {
            this.hide.emit(animation);
        }
    }
    execCallback(option) {
        if (option && typeof option.callback === 'function') {
            option.callback();
        }
    }
    generateQeId(option) {
        return (option &&
            option.name &&
            'widget-edit-' +
                option.name
                    .toLocaleLowerCase()
                    .replace(/[^a-z ]/g, '')
                    .replace(/\s+/g, '-'));
    }
}
WidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: WidgetComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
WidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: WidgetComponent, selector: "lib-widget", inputs: { header: "header", hideCard: "hideCard", editOptions: "editOptions", name: "name" }, outputs: { hide: "hide", sizeChange: "sizeChange" }, host: { properties: { "class.moveable": "this.moveableClass" } }, ngImport: i0, template: "<div class=\"widget-card-container\" [class.card]=\"!hideCard || isEditMode\" qe-id=\"dashboard-widget\">\n\t<h3 class=\"card-header\" *ngIf=\"!hideCard || isEditMode\">\n\t\t<span class=\"header-title\">{{header}}</span>\n\t\t<div class=\"options-icon\" *ngIf=\"isEditMode\" ngbDropdown placement=\"bottom-right\">\n\t\t\t<button\n\t\t\t\tclass=\"btn btn-icon btn-small edit-button\"\n\t\t\t\t(click)=\"toggleHidden(true)\"\n\t\t\t\tqe-id=\"widget-edit-option-hide\"\n\t\t\t\t[ngbTooltip]=\"'Blue.Dashboard.Hide' | translate\"\n\t\t\t\tplacement=\"bottom\"\n\t\t\t>\n\t\t\t\t<em class=\"bento-icon-hide\"></em>\n\t\t\t</button>\n\t\t\t<button ngbDropdownToggle class=\"btn btn-icon btn-small cog-button\" *ngIf=\"editOptions\" qe-id=\"widget-config-button\">\n\t\t\t\t<em class=\"bento-icon-cog\"></em>\n\t\t\t</button>\n\t\t\t<div ngbDropdownMenu qe-id=\"widget-config-dropdown\">\n\t\t\t\t<button\n\t\t\t\t\tclass=\"dropdown-item\"\n\t\t\t\t\t*ngFor=\"let option of editOptions\"\n\t\t\t\t\t(click)=\"execCallback(option)\"\n\t\t\t\t\tngattr\n\t\t\t\t\t[attr.qe-id]=\"generateQeId(option)\"\n\t\t\t\t>\n\t\t\t\t\t<em class=\"button-icon\" [ngClass]=\"option.icon\"></em>\n\t\t\t\t\t<span class=\"button-text\">{{option.name}}</span>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</h3>\n\t<div [class.card-body]=\"!hideCard || isEditMode\" qe-id=\"widget-content\">\n\t\t<ng-content></ng-content>\n\t</div>\n</div>\n", styles: [":host{display:block;margin:10px;position:absolute}:host.muuri-item.moveable{cursor:move}:host.muuri-item-dragging.moveable{cursor:grabbing;z-index:3}:host.muuri-item-releasing.moveable{z-index:2}.widget-card-container{height:100%}.dropdown-item,.card-header{display:flex}.button-text,.header-title{flex:1 0 auto;margin:2px 0}.button-icon{flex:0 1 auto;margin-right:10px}.dropdown-item,.options-icon{cursor:pointer}.options-icon{display:flex;flex-direction:row}.edit-button{border:1px solid;font-size:13px;height:20px;line-height:0;margin:0;padding:0;width:20px}.cog-button{border:1px solid;font-size:13px;height:20px;line-height:0;margin-left:10px;padding:0;width:20px}.card-body{padding:0}\n"], directives: [{ type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgbDropdown, selector: "[ngbDropdown]", inputs: ["open", "placement", "container", "autoClose", "display", "dropdownClass"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i2.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i2.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: WidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-widget', template: "<div class=\"widget-card-container\" [class.card]=\"!hideCard || isEditMode\" qe-id=\"dashboard-widget\">\n\t<h3 class=\"card-header\" *ngIf=\"!hideCard || isEditMode\">\n\t\t<span class=\"header-title\">{{header}}</span>\n\t\t<div class=\"options-icon\" *ngIf=\"isEditMode\" ngbDropdown placement=\"bottom-right\">\n\t\t\t<button\n\t\t\t\tclass=\"btn btn-icon btn-small edit-button\"\n\t\t\t\t(click)=\"toggleHidden(true)\"\n\t\t\t\tqe-id=\"widget-edit-option-hide\"\n\t\t\t\t[ngbTooltip]=\"'Blue.Dashboard.Hide' | translate\"\n\t\t\t\tplacement=\"bottom\"\n\t\t\t>\n\t\t\t\t<em class=\"bento-icon-hide\"></em>\n\t\t\t</button>\n\t\t\t<button ngbDropdownToggle class=\"btn btn-icon btn-small cog-button\" *ngIf=\"editOptions\" qe-id=\"widget-config-button\">\n\t\t\t\t<em class=\"bento-icon-cog\"></em>\n\t\t\t</button>\n\t\t\t<div ngbDropdownMenu qe-id=\"widget-config-dropdown\">\n\t\t\t\t<button\n\t\t\t\t\tclass=\"dropdown-item\"\n\t\t\t\t\t*ngFor=\"let option of editOptions\"\n\t\t\t\t\t(click)=\"execCallback(option)\"\n\t\t\t\t\tngattr\n\t\t\t\t\t[attr.qe-id]=\"generateQeId(option)\"\n\t\t\t\t>\n\t\t\t\t\t<em class=\"button-icon\" [ngClass]=\"option.icon\"></em>\n\t\t\t\t\t<span class=\"button-text\">{{option.name}}</span>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</h3>\n\t<div [class.card-body]=\"!hideCard || isEditMode\" qe-id=\"widget-content\">\n\t\t<ng-content></ng-content>\n\t</div>\n</div>\n", styles: [":host{display:block;margin:10px;position:absolute}:host.muuri-item.moveable{cursor:move}:host.muuri-item-dragging.moveable{cursor:grabbing;z-index:3}:host.muuri-item-releasing.moveable{z-index:2}.widget-card-container{height:100%}.dropdown-item,.card-header{display:flex}.button-text,.header-title{flex:1 0 auto;margin:2px 0}.button-icon{flex:0 1 auto;margin-right:10px}.dropdown-item,.options-icon{cursor:pointer}.options-icon{display:flex;flex-direction:row}.edit-button{border:1px solid;font-size:13px;height:20px;line-height:0;margin:0;padding:0;width:20px}.cog-button{border:1px solid;font-size:13px;height:20px;line-height:0;margin-left:10px;padding:0;width:20px}.card-body{padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { header: [{
                type: Input
            }], hideCard: [{
                type: Input
            }], editOptions: [{
                type: Input
            }], name: [{
                type: Input
            }], hide: [{
                type: Output
            }], sizeChange: [{
                type: Output
            }], moveableClass: [{
                type: HostBinding,
                args: ['class.moveable']
            }] } });

class SectionComponent {
    constructor(cd, element) {
        this.cd = cd;
        this.element = element;
        /**
         * Callback to return the section data that now is visible
         */
        this.sectionIsVisible = new EventEmitter();
        /**
         * Callback to return the widget data that now is visible
         */
        this.widgetIsVisible = new EventEmitter();
        this.isOnScreen = false;
        this.hasWidgets = false;
        this.isEditMode = false;
        this.visible = true;
        this.hiddenWidgets = [];
        this.parentDOM = null;
    }
    ngAfterContentInit() {
        this.afterContentInit(this.contentChildren);
        this.contentSub = this.contentChildren.changes.subscribe((children) => {
            this.afterContentInit(children);
        });
    }
    ngAfterViewInit() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: [0, 0.5],
        };
        const callback = (entries, observer) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting && this.isOnScreen) {
                    this.isOnScreen = false;
                }
                else if (entry.isIntersecting && !this.isOnScreen) {
                    this.isOnScreen = true;
                }
            });
        };
        this.grid = new Muuri(this.element.nativeElement.querySelector('[widget-container]'), {
            dragEnabled: true,
            dragStartPredicate: (item, event) => {
                return this.isEditMode && Muuri.ItemDrag.defaultStartPredicate(item, event);
            },
            dragSortHeuristics: {
                sortInterval: 100,
                minDragDistance: 10,
                minBounceBackAngle: 1,
            },
            dragSortPredicate: {
                threshold: 5,
                action: 'move',
            },
            layoutOnResize: 250,
        });
        this.observer = new IntersectionObserver(callback, options);
        this.observer.observe(this.element.nativeElement);
        if (this.preferences) {
            this.loadWidgetPreferences();
        }
    }
    ngOnChanges(changes) {
        if (changes.refreshLayout && changes.refreshLayout.currentValue) {
            this.refreshGrid();
        }
    }
    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.contentSub) {
            this.contentSub.unsubscribe();
        }
        this.contentChildren.forEach(child => {
            child.hide.unsubscribe();
            child.sizeChange.unsubscribe();
        });
    }
    toggleEditMode(isActive) {
        this.isEditMode = isActive;
        this.contentChildren.forEach(widget => {
            widget.toggleEditMode(isActive);
        });
    }
    toggleSectionVisible(isVisible) {
        this.visible = isVisible;
        if (!this.visible) {
            setTimeout(() => {
                this.parentDOM = this.element.nativeElement.parentElement;
                this.element.nativeElement.parentElement.removeChild(this.element.nativeElement);
            }, 500);
        }
        else {
            // Insert the element before the spacer but after the last section
            const lastChild = this.parentDOM.children.item(this.parentDOM.children.length - 1);
            this.parentDOM.insertBefore(this.element.nativeElement, lastChild);
            this.sectionIsVisible.emit(this.contentChildren);
        }
    }
    isSectionVisible() {
        return this.visible && (this.hasWidgets || this.isEditMode);
    }
    save() {
        const section = { id: this.id, widgets: [], visible: this.visible };
        const gridItems = this.grid.getItems();
        gridItems.forEach(item => {
            const i = this.contentChildren.toArray().findIndex(widget => widget.element.nativeElement === item.getElement());
            section.widgets.push({ id: i, visible: item.isActive() });
        });
        return section;
    }
    loadWidgetPreferences() {
        if (this.grid) {
            this.grid.sort((a, b) => {
                const domAIndex = this.contentChildren
                    .toArray()
                    .findIndex(widget => widget.element.nativeElement === a.getElement());
                const domBIndex = this.contentChildren
                    .toArray()
                    .findIndex(widget => widget.element.nativeElement === b.getElement());
                const posA = this.preferences.findIndex(widget => widget.id === domAIndex);
                const posB = this.preferences.findIndex(widget => widget.id === domBIndex);
                return posA - posB;
            }, { layout: 'instant' });
            this.preferences.forEach(widget => {
                if (!widget.visible && widget.id < this.contentChildren.length) {
                    this.contentChildren.toArray()[widget.id].toggleHidden(true, false);
                }
            });
            this.cd.detectChanges();
        }
    }
    /**
     * Sets a widget to be visible
     * @param widget The widget to show
     * @param index the index in the hiddenWidgets array
     */
    toggleWidgetVisible(widget, index) {
        widget.toggleHidden(false);
        const item = this.grid.getItems([widget.element.nativeElement])[0];
        this.grid.show([item]);
        this.hiddenWidgets.splice(index, 1);
        this.checkSectionHasWidgets();
        this.widgetIsVisible.emit(widget);
        setTimeout(() => {
            this.refreshGrid();
        }, 900);
    }
    afterContentInit(children) {
        this.hiddenWidgets = [];
        children.forEach(child => {
            if (child.isHidden) {
                this.hiddenWidgets.push(child);
            }
            if (child.hide.observers.length === 0) {
                child.hide.subscribe(animation => {
                    const item = this.grid.getItems([child.element.nativeElement])[0];
                    this.grid.hide([item], { instant: !animation });
                    this.hiddenWidgets.push(child);
                    this.checkSectionHasWidgets();
                });
                child.sizeChange.subscribe(() => {
                    this.refreshGrid();
                });
            }
            if (this.grid) {
                // If the element isn't in our grid, add it!
                if (this.grid.getItems(child.element.nativeElement).length === 0) {
                    this.grid.add(child.element.nativeElement, { layout: false });
                }
            }
        });
        this.checkSectionHasWidgets();
        this.refreshGrid();
        if (this.preferences) {
            this.loadWidgetPreferences();
        }
    }
    checkSectionHasWidgets() {
        if (this.contentChildren && this.hiddenWidgets) {
            this.hasWidgets = this.contentChildren.length > 0 && this.hiddenWidgets.length < this.contentChildren.length;
        }
        else {
            this.hasWidgets = false;
        }
    }
    refreshGrid() {
        if (this.grid) {
            this.grid.refreshItems().layout(true);
        }
    }
}
SectionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SectionComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SectionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: SectionComponent, selector: "lib-section", inputs: { header: "header", name: "name", icon: "icon", refreshLayout: "refreshLayout", sectionId: "sectionId" }, outputs: { sectionIsVisible: "sectionIsVisible", widgetIsVisible: "widgetIsVisible" }, queries: [{ propertyName: "contentChildren", predicate: WidgetComponent }], usesOnChanges: true, ngImport: i0, template: "<div class=\"section\" [@hidden]=\"isSectionVisible() ? 'visible': 'invisible'\" dash-section qe-id=\"dashboard-section\">\n\t<div class=\"outer-section-header\" tabindex=\"-1\" id=\"{{sectionId}}\">\n\t\t<h2 [@hidden]=\"isSectionVisible() ? 'headerVisible': 'headerInvisible'\" class=\"section-header\">{{header}}</h2>\n\t</div>\n\t<div\n\t\tclass=\"widget-container\"\n\t\t[class.empty]=\"hiddenWidgets.length === contentChildren.length\"\n\t\twidget-container\n\t\tqe-id=\"section-widget-container\"\n\t>\n\t\t<ng-content></ng-content>\n\t</div>\n\t<div class=\"hidden-widgets\" *ngIf=\"isEditMode && hiddenWidgets.length > 0\" qe-id=\"section-hidden-widget-container\">\n\t\t<button\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t*ngFor=\"let widget of hiddenWidgets; let i = index\"\n\t\t\t(click)=\"toggleWidgetVisible(widget, i)\"\n\t\t\tqe-id=\"section-show-widget-button\"\n\t\t>\n\t\t\t<i class=\"bento-icon-eye widget-button\"></i>\n\t\t\t<span\n\t\t\t\tclass=\"widget-title\"\n\t\t\t\t[translate]=\"'Blue.Dashboard.ShowWidget'\"\n\t\t\t\t[translateParams]=\"{name: widget.header ? widget.header : ''}\"\n\t\t\t></span>\n\t\t</button>\n\t</div>\n</div>\n", styles: [":host{width:100%}.section{padding:0 5px;width:100%}.section-content{height:calc(100% - 86px);width:100%}.section-header{color:#fff;font-size:30px;margin:50px 0 0;padding-left:15px;width:100%}.widget-container{display:block;height:calc(100% - 86px);padding:15px;position:relative;width:100%}.widget-container.empty{padding:0}.hidden-widgets{display:flex;flex-wrap:wrap;padding:15px}.hidden-widgets button{flex:0 0 auto;margin:0 20px 20px 0}.outer-section-header:focus-visible{border:none;outline:none!important}\n"], directives: [{ type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$1.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }], animations: [
        trigger('hidden', [
            state('visible', style({ opacity: 1, height: '*' })),
            state('invisible', style({ opacity: 0, height: '0' })),
            state('headerVisible', style({ margin: '*', height: '*' })),
            state('headerInvisible', style({ margin: 0, height: '0' })),
            transition('visible => invisible', [animate('.5s')]),
            transition('invisible => visible', [animate('.5s')]),
            transition('headerVisible => headerInvisible', [animate('.2s')]),
            transition('headerInvisible => headerVisible', [animate('.2s')]),
        ]),
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-section', animations: [
                        trigger('hidden', [
                            state('visible', style({ opacity: 1, height: '*' })),
                            state('invisible', style({ opacity: 0, height: '0' })),
                            state('headerVisible', style({ margin: '*', height: '*' })),
                            state('headerInvisible', style({ margin: 0, height: '0' })),
                            transition('visible => invisible', [animate('.5s')]),
                            transition('invisible => visible', [animate('.5s')]),
                            transition('headerVisible => headerInvisible', [animate('.2s')]),
                            transition('headerInvisible => headerVisible', [animate('.2s')]),
                        ]),
                    ], template: "<div class=\"section\" [@hidden]=\"isSectionVisible() ? 'visible': 'invisible'\" dash-section qe-id=\"dashboard-section\">\n\t<div class=\"outer-section-header\" tabindex=\"-1\" id=\"{{sectionId}}\">\n\t\t<h2 [@hidden]=\"isSectionVisible() ? 'headerVisible': 'headerInvisible'\" class=\"section-header\">{{header}}</h2>\n\t</div>\n\t<div\n\t\tclass=\"widget-container\"\n\t\t[class.empty]=\"hiddenWidgets.length === contentChildren.length\"\n\t\twidget-container\n\t\tqe-id=\"section-widget-container\"\n\t>\n\t\t<ng-content></ng-content>\n\t</div>\n\t<div class=\"hidden-widgets\" *ngIf=\"isEditMode && hiddenWidgets.length > 0\" qe-id=\"section-hidden-widget-container\">\n\t\t<button\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t*ngFor=\"let widget of hiddenWidgets; let i = index\"\n\t\t\t(click)=\"toggleWidgetVisible(widget, i)\"\n\t\t\tqe-id=\"section-show-widget-button\"\n\t\t>\n\t\t\t<i class=\"bento-icon-eye widget-button\"></i>\n\t\t\t<span\n\t\t\t\tclass=\"widget-title\"\n\t\t\t\t[translate]=\"'Blue.Dashboard.ShowWidget'\"\n\t\t\t\t[translateParams]=\"{name: widget.header ? widget.header : ''}\"\n\t\t\t></span>\n\t\t</button>\n\t</div>\n</div>\n", styles: [":host{width:100%}.section{padding:0 5px;width:100%}.section-content{height:calc(100% - 86px);width:100%}.section-header{color:#fff;font-size:30px;margin:50px 0 0;padding-left:15px;width:100%}.widget-container{display:block;height:calc(100% - 86px);padding:15px;position:relative;width:100%}.widget-container.empty{padding:0}.hidden-widgets{display:flex;flex-wrap:wrap;padding:15px}.hidden-widgets button{flex:0 0 auto;margin:0 20px 20px 0}.outer-section-header:focus-visible{border:none;outline:none!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }]; }, propDecorators: { contentChildren: [{
                type: ContentChildren,
                args: [WidgetComponent]
            }], header: [{
                type: Input
            }], name: [{
                type: Input
            }], icon: [{
                type: Input
            }], refreshLayout: [{
                type: Input
            }], sectionIsVisible: [{
                type: Output
            }], widgetIsVisible: [{
                type: Output
            }], sectionId: [{
                type: Input
            }] } });

class DashboardComponent {
    constructor(cd, element, breakpointObserver, translate) {
        this.cd = cd;
        this.element = element;
        this.translate = translate;
        /**
         * Callback to return data on save
         */
        this.save = new EventEmitter();
        /**
         * Callback to return the content which contains sections and widget visibility once initialized
         */
        this.contentInitialized = new EventEmitter();
        /**
         * Callback to return if the dashboard is on Edit Mode when this status change
         */
        this.editModeChange = new EventEmitter();
        /**
         * Allows the dashboard to be edited
         */
        this.isEditable = true;
        /**
         * An Array of component instances for Sections
         */
        this.sectionLinks = [];
        /**
         * An Array of component instances for Sections
         */
        this.hiddenLinks = [];
        /**
         * If true, the dashboard will be editable
         */
        this.isEditMode = false;
        this.editAriaLabel = this.translate.instant('Blue.Dashboard.EditButton.NotChecked');
        this.dashboardTitle = this.translate.instant('Blue.Dashboard.ToggleModeButton');
        this.isLoadingPreferences = false;
        this.firstCheck = true;
        this.isSmallScreen$ = breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall]).pipe(map(result => {
            return result.matches;
        }));
    }
    initContent() {
        this.getSectionLinks(this.contentChildren);
        // When we change the number of sections dynamically
        this.contentSub = this.contentChildren.changes.subscribe((children) => {
            this.getSectionLinks(children);
            // The bottom spacer needs to be recalculated in case the last section was removed
            this.updateBottomHeight();
        });
        // Recalculate the bottom spacer on window resize
        this.reseizeSub = fromEvent(window, 'resize')
            .pipe(debounceTime(250))
            .subscribe(() => {
            // We do this on a timeout to account for widgets reordering
            setTimeout(this.updateBottomHeight, 10);
        });
    }
    ngAfterViewInit() {
        setTimeout(() => this.initContent());
    }
    /**
     * After the sections have been added to the DOM and all of the content has settled
     */
    ngAfterViewChecked() {
        // We only want to check this once in order to improve performace.
        // This function is run frequently, but it happens last so we need this logic to run here
        if (this.firstCheck) {
            if (this.contentChildren.length > 0) {
                this.updateBottomHeight();
                this.firstCheck = false;
            }
            this.cd.detectChanges();
        }
    }
    ngOnDestroy() {
        if (this.reseizeSub) {
            this.reseizeSub.unsubscribe();
        }
        if (this.contentSub) {
            this.contentSub.unsubscribe();
        }
    }
    ngOnChanges(changes) {
        if (changes.preferences && changes.preferences.currentValue && this.contentChildren) {
            this.getSectionLinks(this.contentChildren);
        }
    }
    /**
     * Scrolls the section of the dashboard into view
     * @param element the elementRef to scroll into view
     * @param sectionId the id to move the focus when press enter on menu
     */
    scrollElement(element, sectionId) {
        var _a;
        try {
            element.nativeElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
        catch (_b) {
            // TODO: Remove this when IE11 is no longer supported.
            // This jumps the section into view as opposed to smoothly scrolling it.
            element.nativeElement.scrollIntoView();
        }
        finally {
            (_a = document.getElementById(sectionId)) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }
    // Counts the number of visible links in the link container
    displayLinkContainer() {
        // If we're in edit mode, we want to see the link container in case we want to display more sections
        if (this.isEditMode) {
            return this.contentChildren.length > 1;
        }
        let numVisible = 0;
        this.contentChildren.forEach(section => {
            if (section.hasWidgets) {
                numVisible++;
            }
        });
        return numVisible > 1 && this.hiddenLinks.length < this.contentChildren.length - 1;
    }
    drop(event) {
        moveItemInArray(this.sectionLinks, event.previousIndex, event.currentIndex);
        const container = this.element.nativeElement.querySelector('[dash-section-container]');
        if (event.currentIndex === this.sectionLinks.length - 1 || (event.previousIndex === 0 && event.currentIndex === 1)) {
            container.insertBefore(container.children[event.previousIndex], container.children[event.currentIndex].nextSibling);
        }
        else {
            container.insertBefore(container.children[event.previousIndex], container.children[event.currentIndex]);
        }
        this.updateBottomHeight();
    }
    moveSection(indexFrom, isUp) {
        let indexTo = indexFrom;
        if (isUp && indexFrom > 0) {
            indexTo = indexFrom - 1;
        }
        else if (!isUp && indexFrom < this.sectionLinks.length - 1) {
            indexTo = indexFrom + 1;
        }
        const dropEvent = {
            currentIndex: indexTo,
            previousIndex: indexFrom,
        };
        this.drop(dropEvent);
        if (isUp) {
            // On a delay because this removes the element from teh DOM. Only happens when it goes up
            setTimeout(() => {
                this.element.nativeElement.querySelectorAll('[drag-icon]')[indexTo].focus();
            });
        }
    }
    toggleEditMode() {
        this.isEditMode = !this.isEditMode;
        this.contentChildren.forEach(section => {
            section.toggleEditMode(this.isEditMode);
        });
        if (this.isEditMode) {
            this.editAriaLabel = this.translate.instant('Blue.Dashboard.EditButton.Checked');
        }
        else {
            this.editAriaLabel = this.translate.instant('Blue.Dashboard.EditButton.NotChecked');
        }
        if (!this.isEditMode) {
            this.onSave();
        }
        setTimeout(() => {
            this.updateBottomHeight();
        });
        this.editModeChange.emit(this.isEditMode);
    }
    /**
     * Moves an element from one array to another while toggling the element's visibility.
     * @param visible Will the section display in the DOM?
     * @param fromId Index of the Section in the fromArray
     * @param fromArray Array to take the element out of
     * @param toArray Array to push the element in to
     */
    toggleSectionVisible(visible, fromId) {
        let fromArray;
        let toArray;
        if (visible) {
            fromArray = this.hiddenLinks;
            toArray = this.sectionLinks;
        }
        else {
            fromArray = this.sectionLinks;
            toArray = this.hiddenLinks;
        }
        const index = fromArray.findIndex(x => x.id === fromId);
        fromArray[index].toggleSectionVisible(visible);
        toArray.push(fromArray[index]);
        fromArray.splice(index, 1);
    }
    /**
     * Used in the html, gets the bottom spacer height
     */
    getBottomSpaceHeight() {
        if (this.bottomHeight) {
            return `calc(100% - ${this.bottomHeight}px)`;
        }
        return '0';
    }
    /**
     * Updates the height of the spacer at the bottom of the dashbaord
     */
    updateBottomHeight() {
        if (this.sectionLinks && this.sectionLinks.length > 0) {
            this.bottomHeight = this.sectionLinks[this.sectionLinks.length - 1].element.nativeElement.clientHeight;
        }
        else {
            this.bottomHeight = 0;
        }
    }
    onSave() {
        const saveData = { sections: [] };
        this.sectionLinks.forEach(section => {
            saveData.sections.push(section.save());
        });
        this.hiddenLinks.forEach(section => {
            saveData.sections.push(section.save());
        });
        this.save.emit(saveData);
    }
    getSectionLinks(contentChildren) {
        this.sectionLinks = [];
        this.hiddenLinks = [];
        contentChildren.forEach((section, i) => {
            section.id = i;
            if (section.visible) {
                this.sectionLinks.push(section);
            }
            else {
                this.hiddenLinks.push(section);
            }
        });
        if (this.preferences && this.preferences.sections) {
            this.isLoadingPreferences = true;
            this.preferences.sections.forEach(section => {
                if (section.id < this.contentChildren.length) {
                    if (!section.visible) {
                        this.toggleSectionVisible(section.visible, section.id);
                    }
                    this.contentChildren.toArray()[section.id].preferences = section.widgets;
                    this.contentChildren.toArray()[section.id].loadWidgetPreferences();
                }
            });
            this.sortSectionLinks();
        }
        this.contentInitialized.emit(this.contentChildren);
    }
    /**
     * Will sort the section links and the DOM.
     * This is a special implementation of quick sort
     */
    sortSectionLinks() {
        setTimeout(() => {
            this.quickSort(this.sectionLinks, 0, this.sectionLinks.length - 1);
            this.updateBottomHeight();
            this.isLoadingPreferences = false;
        }, 500);
    }
    quickSort(arr, low, high) {
        if (low < high) {
            const pi = this.partition(arr, low, high);
            this.quickSort(arr, low, pi - 1);
            this.quickSort(arr, pi + 1, high);
        }
    }
    partition(arr, low, high) {
        const pivot = this.preferences.sections.findIndex(section => section.id === arr[high].id);
        let i = low - 1;
        for (let j = low; j < high; j++) {
            const toCompare = this.preferences.sections.findIndex(section => section.id === arr[j].id);
            if (toCompare <= pivot) {
                i++;
                this.swapContent(i, j, arr);
            }
        }
        this.swapContent(i + 1, high, arr);
        return i + 1;
    }
    swapContent(from, to, arr) {
        const temp = arr[from];
        arr[from] = arr[to];
        arr[to] = temp;
        if (from === to) {
            return;
        }
        const container = this.element.nativeElement.querySelector('[dash-section-container]');
        container.insertBefore(container.children[from], container.children[to].nextSibling);
        // If the move was greater than one element away we need to do a swap
        if (Math.abs(from - to) > 1) {
            container.insertBefore(container.children[to - 1], container.children[from]);
        }
    }
}
DashboardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DashboardComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i1$1.BreakpointObserver }, { token: i2$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
DashboardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DashboardComponent, selector: "lib-dashboard", inputs: { customBackground: "customBackground", isEditable: "isEditable", preferences: "preferences" }, outputs: { save: "save", contentInitialized: "contentInitialized", editModeChange: "editModeChange" }, queries: [{ propertyName: "contentChildren", predicate: SectionComponent }], usesOnChanges: true, ngImport: i0, template: "<div\n\tclass=\"dashboard\"\n\t[ngClass]=\"customBackground\"\n\t[class.default-background]=\"!customBackground\"\n\t[class.default-edit-background]=\"isEditMode\"\n\t[class.loading]=\"isLoadingPreferences\"\n\tqe-id=\"dashboard\"\n>\n\t<div\n\t\tclass=\"link-container\"\n\t\trole=\"navigation\"\n\t\t[@linkWidth]=\"(isSmallScreen$ | async) ? 'small' : 'full'\"\n\t\t*ngIf=\"displayLinkContainer()\"\n\t\tqe-id=\"link-container\"\n\t>\n\t\t<div\n\t\t\t*ngIf=\"isEditMode || sectionLinks.length > 1\"\n\t\t\tclass=\"section-list\"\n\t\t\t[class.drag-disabled]=\"!isEditMode\"\n\t\t\tcdkDropList\n\t\t\t(cdkDropListDropped)=\"drop($event)\"\n\t\t\t[cdkDropListDisabled]=\"!isEditMode\"\n\t\t>\n\t\t\t<div\n\t\t\t\t*ngFor=\"let link of sectionLinks; let i = index\"\n\t\t\t\tcdkDrag\n\t\t\t\tcdkDragLockAxis=\"y\"\n\t\t\t\tclass=\"list-element\"\n\t\t\t\trole=\"presentation\"\n\t\t\t>\n\t\t\t\t<div\n\t\t\t\t\tclass=\"click-area\"\n\t\t\t\t\trole=\"button\"\n\t\t\t\t\t[class.active]=\"link.isOnScreen\"\n\t\t\t\t\tqe-id=\"nav-link-edit-visible\"\n\t\t\t\t\t(click)=\"!isEditMode && scrollElement(link.element, link.sectionId)\"\n\t\t\t\t\t(keyup.enter)=\"!isEditMode && scrollElement(link.element, link.sectionId)\"\n\t\t\t\t\t[tabIndex]=\"!isEditMode ? 0 : -1\"\n\t\t\t\t>\n\t\t\t\t\t<i\n\t\t\t\t\t\tclass=\"bento-icon-vertical-drag-drop drag-icon\"\n\t\t\t\t\t\t*ngIf=\"isEditMode\"\n\t\t\t\t\t\tdrag-icon\n\t\t\t\t\t\ttabindex=\"0\"\n\t\t\t\t\t\t(keyup.arrowup)=\"moveSection(i, true)\"\n\t\t\t\t\t\t(keyup.arrowdown)=\"moveSection(i, false)\"\n\t\t\t\t\t\tqe-id=\"nav-link-drag-icon\"\n\t\t\t\t\t></i>\n\t\t\t\t\t<i [class]=\"link.icon ? link.icon : 'bento-icon-grid'\"></i>\n\t\t\t\t\t<div class=\"link-title\" *ngIf=\"!(isSmallScreen$ | async)\">{{link.header}}</div>\n\t\t\t\t\t<i\n\t\t\t\t\t\t(click)=\"toggleSectionVisible(false, link.id)\"\n\t\t\t\t\t\t*ngIf=\"isEditMode\"\n\t\t\t\t\t\t(keyup.enter)=\"toggleSectionVisible(false, link.id)\"\n\t\t\t\t\t\tclass=\"visibility-toggle bento-icon-hide\"\n\t\t\t\t\t\t[ngbTooltip]=\"'Blue.Dashboard.Hide' | translate\"\n\t\t\t\t\t\tplacement=\"bottom\"\n\t\t\t\t\t\ttabindex=\"0\"\n\t\t\t\t\t\tqe-id=\"nav-link-hide-icon\"\n\t\t\t\t\t></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"edit-link-seperator\" *ngIf=\"hiddenLinks.length > 0 && isEditMode\"></div>\n\t\t\t<div *ngIf=\"isEditMode\">\n\t\t\t\t<div *ngFor=\"let link of hiddenLinks; let i = index\" class=\"list-element\">\n\t\t\t\t\t<div class=\"click-area\" qe-id=\"nav-link-edit-invisible\">\n\t\t\t\t\t\t<i class=\"bento-icon-vertical-drag-drop drag-icon-placeholder\"></i>\n\t\t\t\t\t\t<i [class]=\"link.icon ? link.icon : 'bento-icon-grid'\"></i>\n\t\t\t\t\t\t<div class=\"link-title\" *ngIf=\"!(isSmallScreen$ | async)\">{{link.header}}</div>\n\t\t\t\t\t\t<i\n\t\t\t\t\t\t\t(click)=\"toggleSectionVisible(true, link.id)\"\n\t\t\t\t\t\t\t(keyup.enter)=\"toggleSectionVisible(true, link.id)\"\n\t\t\t\t\t\t\tclass=\"visibility-toggle bento-icon-eye\"\n\t\t\t\t\t\t\t[ngbTooltip]=\"'Blue.Dashboard.Show' | translate\"\n\t\t\t\t\t\t\tplacement=\"bottom\"\n\t\t\t\t\t\t\ttabindex=\"0\"\n\t\t\t\t\t\t\tqe-id=\"nav-link-show-icon\"\n\t\t\t\t\t\t></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div\n\t\tclass=\"widget-container\"\n\t\tdash-section-container\n\t\t[class.no-links]=\"!displayLinkContainer()\"\n\t\tqe-id=\"dashboard-widget-container\"\n\t>\n\t\t<ng-content></ng-content>\n\t\t<div class=\"bottom-spacer\" [style.height]=\"getBottomSpaceHeight()\"></div>\n\t</div>\n\t<div class=\"edit-button\" *ngIf=\"isEditable\">\n\t\t<button\n\t\t\tclass=\"btn btn-icon btn-lg\"\n\t\t\t[class.btn-enabled]=\"isEditMode\"\n\t\t\t[class.btn-default]=\"!isEditMode\"\n\t\t\t(click)=\"toggleEditMode()\"\n\t\t\ttabindex=\"0\"\n\t\t\tid=\"dashboard-edit-button\"\n\t\t\t[attr.aria-label]=\"editAriaLabel\"\n\t\t\tqe-id=\"dashboard-edit-button\"\n\t\t\ttitle=\"{{dashboardTitle}}\"\n\t\t>\n\t\t\t<span class=\"sr-only\" [translate]=\"'Blue.Dashboard.ToggleModeButton'\"></span>\n\t\t\t<i class=\"bento-icon-edit\" id=\"isNotEditMode\" *ngIf=\"!isEditMode\"></i>\n\t\t\t<i class=\"bento-icon-checkmark\" id=\"inEditMode\" *ngIf=\"isEditMode\"></i>\n\t\t</button>\n\t</div>\n</div>\n", styles: [".dashboard{background-repeat:no-repeat;background-size:cover;display:flex;flex-direction:row;height:100%;overflow:auto;width:100%}.dashboard.loading{overflow:hidden}.list-element{color:#fff;font-family:KnowledgeBold;font-size:12px;letter-spacing:1px;padding:0 0 35px;text-transform:uppercase}.list-element .click-area{cursor:pointer;display:flex;opacity:.65}.list-element .click-area:hover,.list-element .click-area:focus,.list-element .click-area.active{opacity:1}.list-element .click-area:focus{outline:1px dotted white}.list-element i{display:inline-block;font-size:25px;margin-right:10px;vertical-align:middle}.list-element i:focus{outline:1px dotted #fff}.list-element i.drag-icon-placeholder{opacity:0}.list-element i.drag-icon-placeholder,.list-element i.drag-icon{font-size:15px;margin-right:5px}.list-element i.visibility-toggle{font-size:15px;margin-left:15px}.list-element i.visibility-toggle:hover{cursor:pointer}.list-element.cdk-drag,.list-element.cdk-drag .click-area{cursor:row-resize}.list-element.cdk-drag-placeholder,.list-element.cdk-drag-placeholder.active,.list-element.cdk-drag-placeholder:hover{opacity:0}.default-background{background-image:linear-gradient(rgba(0,0,0,.5),rgba(0,0,0,.6))}.default-edit-background{background-image:linear-gradient(rgba(0,0,0,.6),rgba(0,0,0,.7))}.widget-container{align-content:flex-start;display:flex;flex:2 1 75%;flex-direction:row;flex-wrap:wrap;height:100%}.link-container{transition:width .5s ease-out;width:300px}.section-list{padding:50px 15px 0 0;position:absolute;width:inherit}.drag-disabled .list-element.cdk-drag,.drag-disabled .list-element.cdk-drag .click-area{cursor:pointer}.section-list.cdk-drop-list-dragging .list-element:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.cdk-drag-animating{transition:transform .3s cubic-bezier(0,0,.2,1)}.bottom-spacer{width:100%}.hidden{display:none}.no-links{padding:0 50px}.edit-button{bottom:40px;position:absolute;right:60px;z-index:3}.edit-button button:focus{outline:1px dotted #000}.edit-button .btn{border:1px solid #606169}.edit-button .btn-enabled{background-color:#ff8000;border-color:#ff8000;color:#fff}.link-title{align-items:center;display:flex}.edit-link-seperator{background-color:#fff;border:1px solid white;margin:0 20px 35px;opacity:.65}@media screen and (min-width: 500px){.edit-button{bottom:30px;position:fixed;right:20px;z-index:3}}\n"], directives: [{ type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "id", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListAutoScrollDisabled", "cdkDropListOrientation", "cdkDropListLockAxis", "cdkDropListData", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragDisabled", "cdkDragStartDelay", "cdkDragLockAxis", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragBoundary", "cdkDragRootElement", "cdkDragData", "cdkDragFreeDragPosition"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { type: i2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i2$1.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }], pipes: { "async": i1.AsyncPipe, "translate": i2$1.TranslatePipe }, animations: [
        trigger('linkWidth', [
            state('full', style({ width: '300px' })),
            state('small', style({ width: '65px' })),
            transition('full => small', [animate('.5s ease-out')]),
            transition('small => full', [animate('.5s ease-out')]),
        ]),
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DashboardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-dashboard', animations: [
                        trigger('linkWidth', [
                            state('full', style({ width: '300px' })),
                            state('small', style({ width: '65px' })),
                            transition('full => small', [animate('.5s ease-out')]),
                            transition('small => full', [animate('.5s ease-out')]),
                        ]),
                    ], template: "<div\n\tclass=\"dashboard\"\n\t[ngClass]=\"customBackground\"\n\t[class.default-background]=\"!customBackground\"\n\t[class.default-edit-background]=\"isEditMode\"\n\t[class.loading]=\"isLoadingPreferences\"\n\tqe-id=\"dashboard\"\n>\n\t<div\n\t\tclass=\"link-container\"\n\t\trole=\"navigation\"\n\t\t[@linkWidth]=\"(isSmallScreen$ | async) ? 'small' : 'full'\"\n\t\t*ngIf=\"displayLinkContainer()\"\n\t\tqe-id=\"link-container\"\n\t>\n\t\t<div\n\t\t\t*ngIf=\"isEditMode || sectionLinks.length > 1\"\n\t\t\tclass=\"section-list\"\n\t\t\t[class.drag-disabled]=\"!isEditMode\"\n\t\t\tcdkDropList\n\t\t\t(cdkDropListDropped)=\"drop($event)\"\n\t\t\t[cdkDropListDisabled]=\"!isEditMode\"\n\t\t>\n\t\t\t<div\n\t\t\t\t*ngFor=\"let link of sectionLinks; let i = index\"\n\t\t\t\tcdkDrag\n\t\t\t\tcdkDragLockAxis=\"y\"\n\t\t\t\tclass=\"list-element\"\n\t\t\t\trole=\"presentation\"\n\t\t\t>\n\t\t\t\t<div\n\t\t\t\t\tclass=\"click-area\"\n\t\t\t\t\trole=\"button\"\n\t\t\t\t\t[class.active]=\"link.isOnScreen\"\n\t\t\t\t\tqe-id=\"nav-link-edit-visible\"\n\t\t\t\t\t(click)=\"!isEditMode && scrollElement(link.element, link.sectionId)\"\n\t\t\t\t\t(keyup.enter)=\"!isEditMode && scrollElement(link.element, link.sectionId)\"\n\t\t\t\t\t[tabIndex]=\"!isEditMode ? 0 : -1\"\n\t\t\t\t>\n\t\t\t\t\t<i\n\t\t\t\t\t\tclass=\"bento-icon-vertical-drag-drop drag-icon\"\n\t\t\t\t\t\t*ngIf=\"isEditMode\"\n\t\t\t\t\t\tdrag-icon\n\t\t\t\t\t\ttabindex=\"0\"\n\t\t\t\t\t\t(keyup.arrowup)=\"moveSection(i, true)\"\n\t\t\t\t\t\t(keyup.arrowdown)=\"moveSection(i, false)\"\n\t\t\t\t\t\tqe-id=\"nav-link-drag-icon\"\n\t\t\t\t\t></i>\n\t\t\t\t\t<i [class]=\"link.icon ? link.icon : 'bento-icon-grid'\"></i>\n\t\t\t\t\t<div class=\"link-title\" *ngIf=\"!(isSmallScreen$ | async)\">{{link.header}}</div>\n\t\t\t\t\t<i\n\t\t\t\t\t\t(click)=\"toggleSectionVisible(false, link.id)\"\n\t\t\t\t\t\t*ngIf=\"isEditMode\"\n\t\t\t\t\t\t(keyup.enter)=\"toggleSectionVisible(false, link.id)\"\n\t\t\t\t\t\tclass=\"visibility-toggle bento-icon-hide\"\n\t\t\t\t\t\t[ngbTooltip]=\"'Blue.Dashboard.Hide' | translate\"\n\t\t\t\t\t\tplacement=\"bottom\"\n\t\t\t\t\t\ttabindex=\"0\"\n\t\t\t\t\t\tqe-id=\"nav-link-hide-icon\"\n\t\t\t\t\t></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"edit-link-seperator\" *ngIf=\"hiddenLinks.length > 0 && isEditMode\"></div>\n\t\t\t<div *ngIf=\"isEditMode\">\n\t\t\t\t<div *ngFor=\"let link of hiddenLinks; let i = index\" class=\"list-element\">\n\t\t\t\t\t<div class=\"click-area\" qe-id=\"nav-link-edit-invisible\">\n\t\t\t\t\t\t<i class=\"bento-icon-vertical-drag-drop drag-icon-placeholder\"></i>\n\t\t\t\t\t\t<i [class]=\"link.icon ? link.icon : 'bento-icon-grid'\"></i>\n\t\t\t\t\t\t<div class=\"link-title\" *ngIf=\"!(isSmallScreen$ | async)\">{{link.header}}</div>\n\t\t\t\t\t\t<i\n\t\t\t\t\t\t\t(click)=\"toggleSectionVisible(true, link.id)\"\n\t\t\t\t\t\t\t(keyup.enter)=\"toggleSectionVisible(true, link.id)\"\n\t\t\t\t\t\t\tclass=\"visibility-toggle bento-icon-eye\"\n\t\t\t\t\t\t\t[ngbTooltip]=\"'Blue.Dashboard.Show' | translate\"\n\t\t\t\t\t\t\tplacement=\"bottom\"\n\t\t\t\t\t\t\ttabindex=\"0\"\n\t\t\t\t\t\t\tqe-id=\"nav-link-show-icon\"\n\t\t\t\t\t\t></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div\n\t\tclass=\"widget-container\"\n\t\tdash-section-container\n\t\t[class.no-links]=\"!displayLinkContainer()\"\n\t\tqe-id=\"dashboard-widget-container\"\n\t>\n\t\t<ng-content></ng-content>\n\t\t<div class=\"bottom-spacer\" [style.height]=\"getBottomSpaceHeight()\"></div>\n\t</div>\n\t<div class=\"edit-button\" *ngIf=\"isEditable\">\n\t\t<button\n\t\t\tclass=\"btn btn-icon btn-lg\"\n\t\t\t[class.btn-enabled]=\"isEditMode\"\n\t\t\t[class.btn-default]=\"!isEditMode\"\n\t\t\t(click)=\"toggleEditMode()\"\n\t\t\ttabindex=\"0\"\n\t\t\tid=\"dashboard-edit-button\"\n\t\t\t[attr.aria-label]=\"editAriaLabel\"\n\t\t\tqe-id=\"dashboard-edit-button\"\n\t\t\ttitle=\"{{dashboardTitle}}\"\n\t\t>\n\t\t\t<span class=\"sr-only\" [translate]=\"'Blue.Dashboard.ToggleModeButton'\"></span>\n\t\t\t<i class=\"bento-icon-edit\" id=\"isNotEditMode\" *ngIf=\"!isEditMode\"></i>\n\t\t\t<i class=\"bento-icon-checkmark\" id=\"inEditMode\" *ngIf=\"isEditMode\"></i>\n\t\t</button>\n\t</div>\n</div>\n", styles: [".dashboard{background-repeat:no-repeat;background-size:cover;display:flex;flex-direction:row;height:100%;overflow:auto;width:100%}.dashboard.loading{overflow:hidden}.list-element{color:#fff;font-family:KnowledgeBold;font-size:12px;letter-spacing:1px;padding:0 0 35px;text-transform:uppercase}.list-element .click-area{cursor:pointer;display:flex;opacity:.65}.list-element .click-area:hover,.list-element .click-area:focus,.list-element .click-area.active{opacity:1}.list-element .click-area:focus{outline:1px dotted white}.list-element i{display:inline-block;font-size:25px;margin-right:10px;vertical-align:middle}.list-element i:focus{outline:1px dotted #fff}.list-element i.drag-icon-placeholder{opacity:0}.list-element i.drag-icon-placeholder,.list-element i.drag-icon{font-size:15px;margin-right:5px}.list-element i.visibility-toggle{font-size:15px;margin-left:15px}.list-element i.visibility-toggle:hover{cursor:pointer}.list-element.cdk-drag,.list-element.cdk-drag .click-area{cursor:row-resize}.list-element.cdk-drag-placeholder,.list-element.cdk-drag-placeholder.active,.list-element.cdk-drag-placeholder:hover{opacity:0}.default-background{background-image:linear-gradient(rgba(0,0,0,.5),rgba(0,0,0,.6))}.default-edit-background{background-image:linear-gradient(rgba(0,0,0,.6),rgba(0,0,0,.7))}.widget-container{align-content:flex-start;display:flex;flex:2 1 75%;flex-direction:row;flex-wrap:wrap;height:100%}.link-container{transition:width .5s ease-out;width:300px}.section-list{padding:50px 15px 0 0;position:absolute;width:inherit}.drag-disabled .list-element.cdk-drag,.drag-disabled .list-element.cdk-drag .click-area{cursor:pointer}.section-list.cdk-drop-list-dragging .list-element:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.cdk-drag-animating{transition:transform .3s cubic-bezier(0,0,.2,1)}.bottom-spacer{width:100%}.hidden{display:none}.no-links{padding:0 50px}.edit-button{bottom:40px;position:absolute;right:60px;z-index:3}.edit-button button:focus{outline:1px dotted #000}.edit-button .btn{border:1px solid #606169}.edit-button .btn-enabled{background-color:#ff8000;border-color:#ff8000;color:#fff}.link-title{align-items:center;display:flex}.edit-link-seperator{background-color:#fff;border:1px solid white;margin:0 20px 35px;opacity:.65}@media screen and (min-width: 500px){.edit-button{bottom:30px;position:fixed;right:20px;z-index:3}}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i1$1.BreakpointObserver }, { type: i2$1.TranslateService }]; }, propDecorators: { contentChildren: [{
                type: ContentChildren,
                args: [SectionComponent]
            }], save: [{
                type: Output
            }], contentInitialized: [{
                type: Output
            }], editModeChange: [{
                type: Output
            }], customBackground: [{
                type: Input
            }], isEditable: [{
                type: Input
            }], preferences: [{
                type: Input
            }] } });

class DashboardModule {
}
DashboardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DashboardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DashboardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DashboardModule, declarations: [DashboardComponent, SectionComponent, WidgetComponent], imports: [CommonModule, NgbTooltipModule, NgbDropdownModule, DragDropModule, LayoutModule, TranslateModule], exports: [DashboardComponent, SectionComponent, WidgetComponent] });
DashboardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DashboardModule, imports: [[CommonModule, NgbTooltipModule, NgbDropdownModule, DragDropModule, LayoutModule, TranslateModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DashboardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, NgbTooltipModule, NgbDropdownModule, DragDropModule, LayoutModule, TranslateModule],
                    declarations: [DashboardComponent, SectionComponent, WidgetComponent],
                    exports: [DashboardComponent, SectionComponent, WidgetComponent],
                }]
        }] });

/*
 * Public API Surface of dashboard
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DashboardComponent, DashboardModule, SectionComponent, WidgetComponent };
